import { maskitoTransform } from "@maskito/core";
export var digitsOnlyMask = {
    mask: /^\d+$/,
};
export var cpfMask = {
    mask: [
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        ".",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
    ],
};
export var birthDateMask = {
    mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
};
export var phoneMask = {
    mask: [
        "(",
        /\d/,
        /\d/,
        ")",
        " ",
        "9",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
    ],
};
export var cepMask = {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/],
};
export var addressNumberMask = {
    mask: /^\d+$/,
    postprocessors: [
        function (_a) {
            var value = _a.value, selection = _a.selection;
            if (value === "")
                return { value: "s/n", selection: selection };
            return { value: value, selection: selection };
        },
    ],
};
export var cpfTransformer = function (value) {
    if (!value)
        return "";
    return maskitoTransform(value, cpfMask);
};
